/**
 * @generated SignedSource<<3ea9e80fa34240d10f71cb702170aef1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "addressLine1"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "addressLine2"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "addressLine3"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "billingPermitted"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "city"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "effectiveFrom"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "effectiveTo"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "legalContractLineOfServiceIds"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "npi"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "phoneNumber"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "postalCode"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "providerId"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "state"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tin"
},
v15 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "addressLine1",
        "variableName": "addressLine1"
      },
      {
        "kind": "Variable",
        "name": "addressLine2",
        "variableName": "addressLine2"
      },
      {
        "kind": "Variable",
        "name": "addressLine3",
        "variableName": "addressLine3"
      },
      {
        "kind": "Variable",
        "name": "billingPermitted",
        "variableName": "billingPermitted"
      },
      {
        "kind": "Variable",
        "name": "city",
        "variableName": "city"
      },
      {
        "kind": "Variable",
        "name": "effectiveFrom",
        "variableName": "effectiveFrom"
      },
      {
        "kind": "Variable",
        "name": "effectiveTo",
        "variableName": "effectiveTo"
      },
      {
        "kind": "Variable",
        "name": "legalContractLineOfServiceIds",
        "variableName": "legalContractLineOfServiceIds"
      },
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "name"
      },
      {
        "kind": "Variable",
        "name": "npi",
        "variableName": "npi"
      },
      {
        "kind": "Variable",
        "name": "phoneNumber",
        "variableName": "phoneNumber"
      },
      {
        "kind": "Variable",
        "name": "postalCode",
        "variableName": "postalCode"
      },
      {
        "kind": "Variable",
        "name": "providerId",
        "variableName": "providerId"
      },
      {
        "kind": "Variable",
        "name": "state",
        "variableName": "state"
      },
      {
        "kind": "Variable",
        "name": "tin",
        "variableName": "tin"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "NewProviderBillingAddressModalMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ProviderMutationGroup",
        "kind": "LinkedField",
        "name": "provider",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v15/*: any*/),
            "concreteType": "ProviderBillingAddressCreatePayload",
            "kind": "LinkedField",
            "name": "createBillingAddress",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "provider",
                "plural": false,
                "selections": [
                  (v16/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProviderBillingAddress",
                    "kind": "LinkedField",
                    "name": "billingAddresses",
                    "plural": true,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "ProviderBillingAddresses_Addresses"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v12/*: any*/),
      (v7/*: any*/),
      (v9/*: any*/),
      (v14/*: any*/),
      (v3/*: any*/),
      (v8/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v13/*: any*/),
      (v11/*: any*/),
      (v10/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Operation",
    "name": "NewProviderBillingAddressModalMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ProviderMutationGroup",
        "kind": "LinkedField",
        "name": "provider",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v15/*: any*/),
            "concreteType": "ProviderBillingAddressCreatePayload",
            "kind": "LinkedField",
            "name": "createBillingAddress",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "provider",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  (v16/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProviderBillingAddress",
                    "kind": "LinkedField",
                    "name": "billingAddresses",
                    "plural": true,
                    "selections": [
                      (v16/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LegalContractLineOfService",
                        "kind": "LinkedField",
                        "name": "lineOfService",
                        "plural": false,
                        "selections": [
                          (v16/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "LineOfService",
                            "kind": "LinkedField",
                            "name": "lineOfService",
                            "plural": false,
                            "selections": [
                              (v17/*: any*/),
                              (v16/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "npi",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "tin",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "billingPermitted",
                        "storageKey": null
                      },
                      (v17/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "addressLine1",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "addressLine2",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "addressLine3",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "city",
                        "storageKey": null
                      },
                      (v18/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "postalCode",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "County",
                        "kind": "LinkedField",
                        "name": "county",
                        "plural": false,
                        "selections": [
                          (v16/*: any*/),
                          (v17/*: any*/),
                          (v18/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "phoneNumber",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "effectiveFrom",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "effectiveTo",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "841013d1ebf3c716ad08d48ee92a057e",
    "id": null,
    "metadata": {},
    "name": "NewProviderBillingAddressModalMutation",
    "operationKind": "mutation",
    "text": "mutation NewProviderBillingAddressModalMutation(\n  $providerId: ID!\n  $legalContractLineOfServiceIds: [ID!]!\n  $npi: String!\n  $tin: String!\n  $billingPermitted: Boolean!\n  $name: String!\n  $addressLine1: String!\n  $addressLine2: String!\n  $addressLine3: String!\n  $city: String!\n  $state: String!\n  $postalCode: String!\n  $phoneNumber: String!\n  $effectiveFrom: DateOnly!\n  $effectiveTo: DateOnly!\n) {\n  provider {\n    createBillingAddress(input: {providerId: $providerId, legalContractLineOfServiceIds: $legalContractLineOfServiceIds, npi: $npi, tin: $tin, billingPermitted: $billingPermitted, name: $name, addressLine1: $addressLine1, addressLine2: $addressLine2, addressLine3: $addressLine3, city: $city, state: $state, postalCode: $postalCode, phoneNumber: $phoneNumber, effectiveFrom: $effectiveFrom, effectiveTo: $effectiveTo}) {\n      provider {\n        __typename\n        id\n        billingAddresses {\n          ...ProviderBillingAddresses_Addresses\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment ProviderBillingAddresses_Addresses on ProviderBillingAddress {\n  id\n  lineOfService {\n    id\n    lineOfService {\n      name\n      id\n    }\n  }\n  npi\n  tin\n  billingPermitted\n  name\n  addressLine1\n  addressLine2\n  addressLine3\n  city\n  state\n  postalCode\n  county {\n    id\n    name\n    state\n  }\n  phoneNumber\n  effectiveFrom\n  effectiveTo\n}\n"
  }
};
})();

node.hash = "be0fa15ad656332c268ec8c0657739c5";

export default node;
